import { QuestionIds } from '../constants/QuestionIds';
import { DefaultQuestionIds } from './DefaultQuestonIds';

export const getQuestionIds = (): QuestionIds[] => {
  return DefaultQuestionIds;
};

export const PersonalizationSectionQuestionIds: QuestionIds[] =
  getQuestionIds();
